import React, { createContext, useState } from "react";

const PrescricaoContext = createContext();

const PrescricaoContextProvider = ({ children }) => {
  const [prescricaoId, setPrescricaoId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mainClient, setMainClient] = useState(null);
  const [expanded, setExpanded] = useState({ history: true, dependents: true });
  const [history, setHistory] = useState([]);
  const [dependents, setDependents] = useState([]);
  const [modalPrescriptionOpen, setModalPrescriptionOpen] = useState(false);

  return (
    <PrescricaoContext.Provider
      value={{
        prescricaoId,
        setPrescricaoId,
        loading,
        setLoading,
        mainClient,
        setMainClient,
        expanded,
        setExpanded,
        history,
        setHistory,
        dependents,
        setDependents,
        modalPrescriptionOpen,
        setModalPrescriptionOpen,
      }}
    >
      {children}
    </PrescricaoContext.Provider>
  );
};

export { PrescricaoContextProvider, PrescricaoContext };
